import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-share",
  templateUrl: "./med-icon-share.component.html",
})
export class MedIconShareComponent extends SvgMixinComponent {}
